import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5298_70082)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
				fill: "#64A100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M52.2048 25.6705L58.6169 38.6618C58.973 39.385 59.6632 39.8862 60.4612 40.0027L74.7978 42.0866C76.8069 42.3789 77.6092 44.8475 76.1562 46.2653L65.7808 56.377C65.2027 56.9397 64.9389 57.7509 65.0752 58.5466L67.524 72.826C67.8669 74.8286 65.7654 76.3541 63.9695 75.4089L51.1453 68.6671C50.4308 68.2912 49.5779 68.2912 48.8657 68.6671L36.0415 75.4089C34.2434 76.3541 32.1441 74.8286 32.487 72.826L34.9358 58.5466C35.0721 57.7509 34.8083 56.9419 34.2302 56.377L23.8547 46.2653C22.3995 44.8475 23.2041 42.3789 25.2132 42.0866L39.5498 40.0027C40.3477 39.8862 41.038 39.385 41.3941 38.6618L47.8062 25.6705C48.7053 23.8504 51.3013 23.8504 52.2004 25.6705H52.2048Z",
				fill: "#FDED32"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66.3523 66.0798C51.1848 64.9478 38.5562 54.713 33.9071 40.8204L25.2 42.0866C23.1909 42.379 22.3885 44.8475 23.8416 46.2653L34.217 56.377C34.7951 56.9398 35.0589 57.7509 34.9226 58.5466L32.4738 72.8261C32.1309 74.8264 34.2324 76.3542 36.0283 75.4089L48.8525 68.6671C49.567 68.2912 50.4198 68.2912 51.1321 68.6671L63.9563 75.4089C65.7544 76.3542 67.8537 74.8286 67.5108 72.8261L66.3545 66.0798H66.3523Z",
				fill: "#F5C02C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50 16.5766C48.6042 16.5766 47.4721 15.4445 47.4721 14.0486V9.44564C47.4721 8.04979 48.6042 6.91772 50 6.91772C51.3958 6.91772 52.5279 8.04979 52.5279 9.44564V14.0486C52.5279 15.4445 51.3958 16.5766 50 16.5766Z",
				fill: "#FDED32"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M74.4417 26.4595C73.4547 25.4726 73.4547 23.8723 74.4417 22.8853L77.6972 19.6298C78.6842 18.6428 80.2844 18.6428 81.2714 19.6298C82.2584 20.6168 82.2584 22.217 81.2714 23.204L78.0159 26.4595C77.0289 27.4465 75.4286 27.4465 74.4417 26.4595Z",
				fill: "#FDED32"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M84.7358 50.7298C84.7358 49.334 85.8678 48.2019 87.2637 48.2019H91.8667C93.2625 48.2019 94.3946 49.334 94.3946 50.7298C94.3946 52.1257 93.2625 53.2577 91.8667 53.2577H87.2637C85.8678 53.2577 84.7358 52.1257 84.7358 50.7298Z",
				fill: "#FDED32"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M74.8549 75.1714C75.8419 74.1844 77.4422 74.1844 78.4292 75.1714L81.6847 78.4269C82.6717 79.4139 82.6717 81.0142 81.6847 82.0012C80.6977 82.9882 79.0974 82.9882 78.1104 82.0012L74.8549 78.7457C73.8679 77.7587 73.8679 76.1584 74.8549 75.1714Z",
				fill: "#FDED32"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50.5847 85.4656C51.9806 85.4656 53.1126 86.5976 53.1126 87.9935V92.5965C53.1126 93.9923 51.9806 95.1244 50.5847 95.1244C49.1889 95.1244 48.0568 93.9923 48.0568 92.5965V87.9935C48.0568 86.5976 49.1889 85.4656 50.5847 85.4656Z",
				fill: "#FDED32"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.1431 75.5847C27.13 76.5717 27.13 78.172 26.1431 79.159L22.8875 82.4145C21.9006 83.4015 20.3003 83.4015 19.3133 82.4145C18.3263 81.4275 18.3263 79.8272 19.3133 78.8402L22.5688 75.5847C23.5558 74.5977 25.1561 74.5977 26.1431 75.5847Z",
				fill: "#FDED32"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.8467 51.3145C15.8467 52.7104 14.7147 53.8425 13.3188 53.8425H8.71582C7.31997 53.8425 6.1879 52.7104 6.1879 51.3145C6.1879 49.9187 7.31997 48.7866 8.71582 48.7866H13.3188C14.7147 48.7866 15.8467 49.9187 15.8467 51.3145Z",
				fill: "#FDED32"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.7298 26.8729C24.7428 27.8599 23.1425 27.8599 22.1555 26.8729L18.9 23.6174C17.913 22.6304 17.913 21.0301 18.9 20.0431C19.887 19.0561 21.4873 19.0561 22.4743 20.0431L25.7298 23.2986C26.7168 24.2856 26.7168 25.8859 25.7298 26.8729Z",
				fill: "#FDED32"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5298_70082",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 100,
			height: 100,
			fill: "white"
		})
	}) })]
});
export default SvgStar;
